// extracted by mini-css-extract-plugin
export default {"container":"MemoCard_container__3lGjO","card":"MemoCard_card__6043d","img":"MemoCard_img__XY2Jb"};